export function arrayMoveItem(arr, from, to) {
    arr.splice(to, 0, arr.splice(from, 1)[0]);
}
export function arraySwapItem(arr, x, y) {
    const b = arr[x];
    arr[x] = arr[y];
    arr[y] = b;
    return arr;
}
//# sourceMappingURL=functions.js.map